import axios from 'axios'

export const fetchPromocodeData = async (projectSlug: string, code: string) =>
  axios.get(`public/v1/promo-codes/${projectSlug}/${code}`)
